import { mergeClassName as e } from "../../utils/data.js";
import t from "./Calendar.module.js";
import n from "../Input/InputBox.module.js";
import { inputBoxClassName as r } from "../Input/inputBoxClassName.js";
import "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region lib/components/DatePicker/DateRangeInputTrigger.tsx
function o({ hasError: o, active: s, disabled: c, fromValue: l, toValue: u, fromPlaceholder: d, toPlaceholder: f, prefix: p, suffix: m, describedBy: h, id: g, className: _, onOpen: v, fromInputProps: y, toInputProps: b }) {
	let x = {
		role: "combobox",
		"aria-expanded": s ?? !1,
		"aria-haspopup": "dialog",
		"aria-describedby": h,
		onClick: () => {
			c || v();
		}
	};
	return /* @__PURE__ */ a("div", {
		className: r({
			hasError: o,
			active: s,
			disabled: c
		}, t.trigger, t.rangeTrigger, _),
		id: g,
		"data-disabled": c ?? void 0,
		...x,
		children: [
			p && /* @__PURE__ */ i("span", {
				className: n.adornment,
				"aria-hidden": !0,
				children: p
			}),
			/* @__PURE__ */ i("input", {
				readOnly: !0,
				disabled: c,
				tabIndex: -1,
				value: l,
				placeholder: d,
				"aria-label": d ?? "From date",
				...y,
				className: e(n.input, t.rangeSegmentInput, y?.className)
			}),
			/* @__PURE__ */ i("span", {
				className: t.rangeDivider,
				"aria-hidden": !0
			}),
			/* @__PURE__ */ i("input", {
				readOnly: !0,
				disabled: c,
				tabIndex: -1,
				value: u,
				placeholder: f,
				"aria-label": f ?? "To date",
				...b,
				className: e(n.input, t.rangeSegmentInput, b?.className)
			}),
			m && /* @__PURE__ */ i("span", {
				className: n.adornment,
				"aria-hidden": !0,
				children: m
			})
		]
	});
}
//#endregion
export { o as DateRangeInputTrigger };
